module.exports = __webpack_public_path__ + "static/media/wenti3.fd588b55.png";